import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductForm from '../../components/Products/ProductForm';
import Toast from '../../components/Common/Toast';
import { useState } from 'react';

const CreateProduct = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Producto creado exitosamente',
      type: 'success'
    });
    // Redirigir después de un breve delay para que se vea el toast
    setTimeout(() => {
      navigate('/products');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/products');
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Producto</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear un nuevo producto</p>
        </div>

        {/* Formulario */}
        <ProductForm
          isOpen={true}
          onClose={handleCancel}
          product={null}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateProduct;

